import { Message } from 'element-ui';

let messageInstance = null;

const resetMessage = (options) => {
  // 如果存在未关闭的实例，先将其关闭
  if (messageInstance) {
    messageInstance.close();
  }
  // 创建新的实例并保存
  messageInstance = Message(options);
};

// 兼容 success, warning, info, error 四种类型
['success', 'warning', 'info', 'error'].forEach(type => {
  resetMessage[type] = options => {
    // 支持直接传入字符串或配置对象
    if (typeof options === 'string') {
      options = { message: options };
    }
    options.type = type;
    return resetMessage(options);
  };
});

export const message = resetMessage;